import { Facet } from '../models/Facet';

/**
 * Facet to apply to an error to provide an HTTP status code.
 */
export const httpStatusErrorFacet = new Facet<number>('httpStatus');

/**
 * Facet to attach to an error indicating that that an item is in conflict.
 */
export const conflictErrorFacet = new Facet<{
  supportsRename?: boolean;
}>('conflict');

/**
 * Facet to attach to an error indicating that the user is offline.
 */
export const offlineErrorFacet = new Facet<{}>('offlineError');

/**
 * Facet to attach to an error indicating that the user does not have access to a resource.
 */
export const accessDeniedErrorFacet = new Facet<{}>('accessDeniedError');

/**
 * Facet to attach to an error indicating that the operation may be retried.
 */
export const retryErrorFacet = new Facet<{}>('retryError');
